const labels = {
  first_name: 'First name', last_name: 'Last name', phone: 'Phone number',
  email: 'Email address', case_type: 'How can we help?', preferred_language: 'Preferred language',
};

export function clearFieldError(field) {
  field.removeAttribute('aria-invalid');
  const id = field.dataset.josErrorId;
  if (!id) return;
  field.ownerDocument.getElementById(id)?.remove();
  const descriptions = (field.getAttribute('aria-describedby') || '').split(' ').filter(value => value && value !== id);
  if (descriptions.length) field.setAttribute('aria-describedby', descriptions.join(' '));
  else field.removeAttribute('aria-describedby');
  delete field.dataset.josErrorId;
}

function fieldMessage(field) {
  if (field.name === 'website') return '';
  if (field.required && (field.type === 'checkbox' ? !field.checked : !field.value.trim())) {
    if (field.name === 'consent') return 'Please check the box to agree to be contacted about your enquiry.';
    return `Please ${field.tagName === 'SELECT' ? 'select' : 'enter'} ${labels[field.name]?.toLowerCase() || 'this field'}.`;
  }
  if (field.name === 'phone' && (!/^\+?[\d\s().-]+$/.test(field.value) || !/^\d{7,20}$/.test(field.value.replace(/\D/g, '')))) {
    return 'Please enter a valid phone number, including the area code.';
  }
  if (field.validity && !field.validity.valid) {
    if (field.name === 'email') return 'Please enter a valid email address, such as name@example.com.';
    return `Please check ${labels[field.name]?.toLowerCase() || 'this field'}.`;
  }
  return '';
}

export function validateLeadForm(form, showError) {
  let firstInvalid;
  let count = 0;
  form.querySelectorAll('input, select, textarea').forEach(field => {
    clearFieldError(field);
    const message = fieldMessage(field);
    if (!message) return;
    count += 1;
    firstInvalid = firstInvalid || field;
    const error = document.createElement('p');
    const id = `${form.id}-${field.name}-error`;
    error.id = id; error.className = 'jos-field-error'; error.textContent = message;
    error.dataset.testid = `${form.dataset.testid}-${field.name.replace(/_/g, '-')}-error`;
    field.dataset.josErrorId = id;
    field.setAttribute('aria-invalid', 'true');
    field.setAttribute('aria-describedby', `${field.getAttribute('aria-describedby') || ''} ${id}`.trim());
    const container = document.createElement('div');
    container.className = 'jos-field-feedback';
    // Keep errors beside the matching input while retaining the original grid tracks.
    if (field.type === 'checkbox') field.closest('label').after(error);
    else if (field.parentElement.classList.contains('jos-field-feedback')) field.after(error);
    else { field.before(container); container.append(field, error); }
  });
  if (firstInvalid) {
    showError(`Please complete ${count === 1 ? 'the highlighted field' : 'the highlighted fields'} before submitting.`, false);
    try { firstInvalid.focus({ preventScroll: true }); } catch { firstInvalid.focus(); }
    firstInvalid.scrollIntoView({ block: 'center', behavior: 'smooth' });
    return false;
  }
  return true;
}